import api from "./BaseServices";

// Define the preference interface for TypeScript
export interface PreferenceData {
  id?: number;
  user_id: number;
  preference_key: string;
  preference_value: string;
  created_at: string;
  updated_at: string;
}

// API base URL (replace with your backend API base URL)
const API_URL = `${process.env.REACT_APP_API_URL}/preferences`; // Modify this if your API is on a different URL

// Function to fetch all preferences with pagination (limit and offset)
export const getPreferences = async (): Promise<PreferenceData[]> => {
  const response = await api.get(API_URL);
  return response.data;
};

// Function to fetch a single preference by ID
export const getPreferenceByKey = async (
  key: string
): Promise<PreferenceData> => {
  const response = await api.get(`${API_URL}/${key}`);
  return response.data;
};

export const addOrUpdatePreference = async (
  preference: Omit<PreferenceData, "created_at" | "updated_at" | "user_id">
): Promise<PreferenceData> => {
  // Check if the preference has an id to determine whether it's an update or create
  const response = await api.post(`${API_URL}`, preference);
  return response.data;
};
